/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import Select from "react-select";
import SelectAsync from "react-select/async";
import {
	formatCurrency,
	money,
} from "../../../utils/helpers";
import PropTypes from "prop-types";

import ItemFotos from "../../Items/ItemFotos";
import Modal from "../../general/Modal";
import useProducto from "./useProducto";
import { aCantidadBase } from "../../../utils/unidades";

const ProductosOrden = ({
	producto,
    productos,
	updateTotal,
	index,
	removeProducto,
	precioLimite,
	banderaContacto,
	impuestosForDropdown,
	facturaProductos,
	isEdit,
	tipoOrden,
	errors,
	contacto,
	unidades
}) => {
    const isInterna = tipoOrden === 'interna';
    const {
        productoInfo,
        total,
        totalReal,
        precioManual,
        pinSeguridad,
        productoITBIS,
        checkPINSeguridad,
        onChangeInput,
        onChangeUnidad,
        setProductoInfo,
        setPrecioManual,
        setPinSeguridad,
        setShowFotos,
        toggleFotosModal,
        toggleDeleteModal,
        togglePINModal,
        showPrecioManual,
        showFotos,
        showDelete,
        showPINModal,
    } = useProducto(producto, facturaProductos, updateTotal, index, impuestosForDropdown, banderaContacto, precioLimite, contacto, isEdit, isInterna);

	if (!productos) {
		return <></>;
	}

	return (
		<>
			<tr>
				<td colSpan={2}>
					<input
						type="hidden"
						name={`productos[${index}][id]`}
						value={isEdit ? producto.id : "random1"}
					/>
                    
					<input
						type="text"
						name={`productos[${index}][nombre_producto]`}
						className="form-control"
						value={producto?.nombre_producto}
						onChange={(e) =>
							onChangeInput("nombre_producto", e.target.value)
						}
					/>

					{errors[`productos.${index}.nombre_producto`] && (
						<small
							className="help-blockParams form-Text d-block"
							style={{ whiteSpace: "nowrap" }}
						>
							{errors[`productos.${index}.nombre_producto`][0]}
						</small>
					)}
				</td>
				<td>
					<input
						type="number"
						name={`productos[${index}][cantidad]`}
						placeholder="Cantidad"
						value={productoInfo.cantidad || undefined}
						step="1"
						min="1"
						onChange={(e) => {
							producto.cantidad = parseFloat(e.target.value || 0);
							onChangeInput("cantidad", e.target.value);
						}}
						className="form-control"
					/>
				</td>
				<td style={{ width: "150px" }}>
					<input type="hidden" name={`productos[${index}][unidad]`} value={productoInfo.unidadSeleccionada?.value ?? productoInfo.unidad ?? ""} />
					<input type="hidden" name={`productos[${index}][factor]`} value={productoInfo.factor ?? 1} />
					<input type="hidden" name={`productos[${index}][cantidad_base]`} value={aCantidadBase(productoInfo.cantidad, productoInfo.factor ?? 1)} />
					<input type="hidden" name={`productos[${index}][unidad_id]`} value={productoInfo.unidadSeleccionada?.unidad_id ?? ""} />
					<Select
						placeholder="Und."
						options={unidades}
						value={
							productoInfo.unidadSeleccionada
								? {
										...productoInfo.unidadSeleccionada,
										label: productoInfo.factor > 1
											? `${productoInfo.unidadSeleccionada.value} (x${productoInfo.factor})`
											: productoInfo.unidadSeleccionada.value,
								  }
								: null
						}
						onChange={(opcion) => onChangeUnidad(opcion)}
						// isDisabled={(productoInfo.unidades?.length ?? 0) <= 1}
						menuPortalTarget={document.body}
						styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
					/>
				</td>
				<td>
                    <input
                        type="number"
						step="0.01"
						min="0"
                        style={{ backgroundColor: "#fff" }}
                        value={productoInfo?.costo}
                        className="form-control"
                        onChange={(e) => {
							setProductoInfo(prev => ({
								...prev,
								costo: e.target.value.replace(/[^0-9.]/g, ""),
							}));

							
							//update el precio manual
							const imp = productoInfo.impuesto?.porcentaje ?? 0;
							const precio = parseFloat(e.target.value || 0) * (1 + imp);
							setPrecioManual(precio.toFixed(2));
						}}
                    />
                    <input
                        type="hidden"
                        name={`productos[${index}][importe]`}
                        className="form-control"
                        value={productoInfo.costo || ''}
                        readOnly
                    />
					{errors[`productos.${index}.importe`] && (
						<small
							className="help-blockParams form-Text d-block"
							style={{ whiteSpace: "nowrap" }}
						>
							{errors[`productos.${index}.importe`][0]}
						</small>
					)}
				</td>
				<td>
					<select
						className="form-control"
						id="impuesto_id"
						name={`productos[${index}][impuesto_id]`}
						value={productoInfo.impuesto?.value}
						onChange={(e) => {
							const impuesto = impuestosForDropdown.find(i => i.value == e.target.value);

							setProductoInfo(prev => {
								return {
									...prev,
									impuesto,
								}
							})

							const costo = parseFloat(productoInfo.costo || 0);
							const precio = costo * (1 + impuesto.porcentaje);
							setPrecioManual(precio.toFixed(2));
						}}
					>
						<option value="">Seleccione...</option>
						{impuestosForDropdown.map((impuesto) => (
							<option value={impuesto.value} key={impuesto.value}>
								{impuesto.label}
							</option>
						))}
					</select>
				</td>
				<td>
					<input
						type="number"
						min={0}
						step={0.01}
						className="form-control"
						name={`productos[${index}][costo]`}
						value={precioManual}
						id={`costo-${index}`}
						onChange={(e) => {
							const precio = Math.abs(parseFloat(e.target.value))

							setPrecioManual(precio)

							const imp = productoInfo.impuesto?.porcentaje ?? 0;
							const costo = precio / (1 + imp);

							setProductoInfo(prev => ({
								...prev,
								costo: costo.toFixed(2)
							}))
						}}
					/>

					{errors[`productos.${index}.costo`] && (
						<small
							className="help-blockParams form-Text d-block"
							style={{ whiteSpace: "nowrap" }}
						>
							{errors[`productos.${index}.costo`][0]}
						</small>
					)}
				</td>
				<td>
                    <input type="hidden" name={`productos[${index}][descuento]`} value="0" />
					<input
						type="number"
						min="0"
						name={`productos[${index}][descuento]`}
						placeholder="Descuento"
						value={productoInfo.descuento || ''}
						step="0.1"
						onChange={(e) =>
							onChangeInput("descuento", Math.abs(parseFloat(e.target.value)))
						}
						className="form-control"
					/>
				</td>
				<td className="text-right">
					{!showPrecioManual ? (
						<input
							type="hidden"
							name={`productos[${index}][precio_facturado]`}
							value={(productoInfo.costo + productoITBIS) || ''}
						/>
					) : (
						<input
							type="hidden"
							name={`productos[${index}][precio_facturado]`}
							value={precioManual}
						/>
					)}

					<input
						type="hidden"
						name={`productos[${index}][total]`}
						value={total}
					/>
					{formatCurrency(productoInfo.descuento > 0 ? totalReal : total)}
				</td>
				<td className="text-center">
					{productoInfo.fotos?.length > 0 && (
						<button
							type="button"
							title="Ver Fotos"
							onClick={() => toggleFotosModal()}
							className="producto"
						>
							<i className="fas fa-eye"></i>
						</button>
					)}
				</td>
				<td className="text-right">
					<button
						type="button"
						className="btn btn-danger"
						onClick={() =>
							isEdit
								? toggleDeleteModal()
								: removeProducto(producto.id)
						}
					>
						<i className="fas fa-trash"></i>
					</button>
				</td>
			</tr>
			{/* {errors[`productos.${index}.total`] && (
				<small
					className="help-blockParams form-Text d-block"
					style={{ whiteSpace: "nowrap" }}
				>
					{errors[`productos.${index}.total`][0]}
				</small>
			)}
			{errors[`productos.${index}.cantidad`] && (
				<small
					className="help-blockParams form-Text d-block"
					style={{ whiteSpace: "nowrap" }}
				>
					{errors[`productos.${index}.cantidad`][0]}
				</small>
			)} */}
			{productoInfo?.fotos && (
				<Modal
					show={showFotos}
					blank={true}
					toggle={() => setShowFotos((state) => !state)}
				>
					<ItemFotos
						toggle={() => setShowFotos((state) => !state)}
						fotos={productoInfo.fotos}
					/>
				</Modal>
			)}
			<Modal
				title="Borrar Producto"
				show={showDelete}
				callback={() => removeProducto(producto.id)}
				acceptText="Borrar"
				toggle={toggleDeleteModal}
			>
				¿Estás seguro de que deseas borrar este producto?
                <div className="alert alert-warning mt-3">{producto?.nombre_producto}</div>
			</Modal>
			{/* <---PIN DE SEGURIDAD MODAL--- */}
			<Modal
				title="PIN de seguridad"
				show={showPINModal}
				callback={() => checkPINSeguridad()}
				acceptText="Aceptar"
				toggle={() => togglePINModal()}
				size="419px"
			>
				<div className="form-group">
					<label>PIN de seguridad</label>
					<input
						type="password"
						className="form-control"
						name="pin_seguridad"
						value={pinSeguridad}
						onChange={(e) => setPinSeguridad(e.target.value)}
					/>
					<p
						className="font-weight-bold"
						style={{
							color: "gray",
							fontStyle: "italic",
							lineHeight: "13px",
							fontSize: "0.7rem",
						}}
					>
						Para continuar ingrese PIN de seguridad
					</p>
				</div>
			</Modal>
		</>
	);
};

ProductosOrden.propTypes = {
	producto: PropTypes.object,
	updateTotal: PropTypes.func,
	productos: PropTypes.array,
	index: PropTypes.number,
	removeProducto: PropTypes.func,
	precioLimite: PropTypes.number,
	impuestosForDropdown: PropTypes.array,
	ordenProductos: PropTypes.array,
	isEdit: PropTypes.bool,
	tipoOrden: PropTypes.string,
};

export default ProductosOrden;
